import { useFeatureValue } from '@monofront/business/contexts';
import { FREE_SHIPPING_THRESHOLD } from '@monofront/business/constants';
import Calendar from '@monofront/design-system/visuals/Illustrations/Calendar';
import PiggyBank from '@monofront/design-system/visuals/Illustrations/PiggyBank';
import Wallet from '@monofront/design-system/visuals/Illustrations/Wallet';
import { IListBox } from '@monofront/design-system/components/ListBox';
import { OurGuaranteesKeys } from '../types';

const useOurSubscriptionGuaranteesContent: () => IListBox<OurGuaranteesKeys> =
  () => {
    const freeShippingThreshold = useFeatureValue(...FREE_SHIPPING_THRESHOLD);

    return {
      title: 'subscription.title',
      lines: [
        {
          icon: Calendar,
          text: 'subscription.line_1',
        },
        {
          icon: Wallet,
          text: 'subscription.line_2',
        },
        {
          icon: PiggyBank,
          text: 'subscription.line_3',
          variables: {
            freeShippingThreshold: freeShippingThreshold.toString(),
          },
        },
      ],
    };
  };

export default useOurSubscriptionGuaranteesContent;
